"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTeamsAndChannels = exports.TeamsAndChannelsProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _PermissionsContext = require("./PermissionsContext");
var _useGetSecretsQuery2 = require("@/api/useGetSecretsQuery");
var _policies = require("@/utils/policies");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var TeamsAndChannelsContext = /*#__PURE__*/(0, _react.createContext)(undefined);
var TeamsAndChannelsProvider = exports.TeamsAndChannelsProvider = function TeamsAndChannelsProvider(_ref) {
  var children = _ref.children;
  var _usePermissions = (0, _PermissionsContext.usePermissions)(),
    hasPermission = _usePermissions.hasPermission;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    teamsAndChannels = _useState2[0],
    setTeamsAndChannels = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    teamsFiles = _useState4[0],
    setTeamsFiles = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedRows = _useState6[0],
    setSelectedRows = _useState6[1];
  var _useGetSecretsQuery = (0, _useGetSecretsQuery2.useGetSecretsQuery)(hasPermission(_policies.Permission.IMPORT_TEAMS)),
    secrets = _useGetSecretsQuery.data,
    secretsLoading = _useGetSecretsQuery.isLoading,
    secretsError = _useGetSecretsQuery.error;
  var _useState7 = (0, _react.useState)({
      auth: {
        clientId: ""
      }
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    msalConfig = _useState8[0],
    setMsalConfig = _useState8[1];
  (0, _react.useEffect)(function () {
    if (!secretsLoading && !secretsError && secrets) {
      var _process$env$REACT_AP;
      setMsalConfig({
        auth: {
          clientId: secrets.AZURE_CLIENT_ID,
          authority: "https://login.microsoftonline.com/".concat(secrets.AZURE_TENANT_ID),
          redirectUri: (_process$env$REACT_AP = process.env.REACT_APP_CC_USER_MANAGEMENT_APP_URL) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : "http://localhost:3001"
        },
        cache: {
          cacheLocation: "localStorage",
          storeAuthStateInCookie: false
        },
        loginRequest: {
          scopes: ["User.Read"]
        },
        backend_uri: {
          scopes: ["api://".concat(secrets.AZURE_CLIENT_ID, "/user_impersonation")]
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secrets === null || secrets === void 0 ? void 0 : secrets.AZURE_CLIENT_ID, secrets === null || secrets === void 0 ? void 0 : secrets.AZURE_TENANT_ID, secretsLoading, secretsError]);
  var value = (0, _react.useMemo)(function () {
    return {
      teamsAndChannels: teamsAndChannels,
      setTeamsAndChannels: setTeamsAndChannels,
      msalConfig: msalConfig,
      teamsFiles: teamsFiles,
      setTeamsFiles: setTeamsFiles,
      selectedRows: selectedRows,
      setSelectedRows: setSelectedRows
    };
  }, [teamsAndChannels, msalConfig, teamsFiles, selectedRows]);
  return /*#__PURE__*/_react["default"].createElement(TeamsAndChannelsContext.Provider, {
    value: value
  }, children);
};
var useTeamsAndChannels = exports.useTeamsAndChannels = function useTeamsAndChannels() {
  var context = (0, _react.useContext)(TeamsAndChannelsContext);
  if (!context) throw new Error("useTeams must be used within a TeamsProvider");
  return context;
};